// @ts-nocheck
import React from 'react';
import { useStores } from 'hooks/useStores.js';

import styles from './styles/get_gift_confirm_form_modal.module.scss';

export const GetGiftConfirmFormModal = () => {
  const { modalStore } = useStores();

  const handleCloseModal = function () {
    modalStore.close();
  };

  return (
    <>
      <div className={styles.modal}>
        <div className={styles.modal__bubble}>
          <h2 className={styles.modal__bubble_text}>
            Заявка на получение подарка отправлена. В ближайшее время мы
            свяжемся с вами для уточнения деталей
          </h2>
          <button className={styles.modal__button} onClick={handleCloseModal}>
            Ладненько
          </button>
        </div>
      </div>
    </>
  );
};
